import React, { useEffect, useRef, useImperativeHandle, forwardRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface SignaturePadProps {
  height?: number;
  maxWidth?: number;
}

export interface SignaturePadRef {
  getSignature: () => string | null;
  clear: () => void;
}

const SignaturePad = forwardRef<SignaturePadRef, SignaturePadProps>(({ height = 200, maxWidth = 600 }, ref) => {
  const signatureRef = useRef<SignatureCanvas>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [canvasWidth, setCanvasWidth] = useState(0);

  useImperativeHandle(ref, () => ({
    getSignature: () => {
      if (signatureRef.current && !signatureRef.current.isEmpty()) {
        return signatureRef.current.toDataURL('image/png');
      }
      return null;
    },
    clear: () => {
      signatureRef.current?.clear();
    }
  }), []);

  useEffect(() => {
    let resizeObserver: ResizeObserver | null = null;
    const updateWidth = () => {
      if (containerRef.current) {
        const width = Math.min(containerRef.current.offsetWidth, maxWidth || 600);
        setCanvasWidth(width);
      }
    };

    if (containerRef.current) {
      resizeObserver = new ResizeObserver(updateWidth);
      resizeObserver.observe(containerRef.current);
      updateWidth(); // Garante atualização inicial
    }

    return () => {
      if (resizeObserver && containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, [maxWidth]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: `${height}px`,
        zIndex: 1,
        margin: 'auto'
      }}
    >
      <SignatureCanvas
        penColor="black"
        maxWidth={2}
        canvasProps={{
          width: canvasWidth || (maxWidth || 600),
          height,
          style: {
            borderRadius: 8,
            height: `${height}px`,
            touchAction: 'none',
            background: '#fff',
            display: 'block',
            width: '100%'
          }
        }}
        ref={signatureRef}
      />
    </div>
  );
});

export default SignaturePad; 